// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/Images/LogIn/LogInBar_mask.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/Images/LogIn/InputOutline_LogIn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/Images/LogIn/InputOutline_Error_LogIn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/Images/LogIn/password_reset_background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#logInContainer {
  display: flex;

  aspect-ratio: 16/9;
  max-width: 100vw;
  max-height: 100vh;

  align-items: center;
  justify-content: center;
}

#logInDiv {
  position: relative;
  aspect-ratio: 16/9;
  max-width: 177.778vh;
  max-height: 56.25vw;
  width: 100%;

  container-type: size;

  overflow: hidden;
}

#emailInput {
  position: absolute;

  left: 8.07%;
}

#passwordInput {
  position: absolute;

  left: 29.4%;
  width: 16%;
}

.textInputs {
  text-align: left;

  top: 30%;
  bottom: 23%;

  width: 17.7%;

  outline: none;
  border: none;
  background: none;

  font: normal normal normal 100% 'MyriadPro-Regular';
  font-size: 35cqh;
  color: white;
}

.textInputs::selection {
  background: white
}

.mask_logInInputs {
  display: flex;

  position: absolute;
  bottom: 0px;
  left: 0%;

  width: 55%;
  height: 5.23148%;

  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-repeat: no-repeat;    
  mask-size: cover;
}

#logInInputs {
  display: flex;

  position: absolute;

  bottom: 0px;
  left: 85%;

  width: 182%;
  height: 100%;

  container-type: size;
}

.logInInputs_StartAnim {
  animation-duration: 0.4s;
  animation-name: start-move-left-LII;
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
}

.logInInputs_EndAnim {
  animation-duration: 0.4s;
  animation-name: end-move-right-LII;
  animation-fill-mode: forwards;
}

#logInBar {
  position: absolute;
  height: 100%;

  left: 3.15104%;
  bottom: 0%;

  opacity: 1;
}

#email_outline {
  position: absolute;
  height: 100%;
  width: 21.4836%;

  left: 6.18%;
}

#password_outline {
  position: absolute;
  height: 100%;
  width: 21.4836%;

  left: 27.469%;
}

.outlineWhite {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;

  opacity: 1;
  z-index: 1;

  pointer-events: none;
}
.outlineRed {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;

  opacity: 1;
  z-index: 1;

  pointer-events: none;
}

#logInBar_message_email {
  position: absolute;
  height: 5.23148%; 

  left: 3.15104%;
  bottom: 0%;

  opacity: 0;

  clip-path: polygon(0% 0%, 52% 0%, 46.5% 100%, 0% 100%);
}

#logInBar_message_password {
  position: absolute;
  height: 5.23148%; 

  left: 24.5%;
  bottom: 0%;

  opacity: 0;

  clip-path: polygon(0% 0%, 56.5% 0%, 50.7% 100%, 0% 100%);
}

#logInBar_message_fullBar {
  position: absolute;
  height: 5.23148%; 

  left: 3.15104%;
  bottom: 0%;

  opacity: 0;

  clip-path: polygon(0% 0%, 99.6% 0%, 94% 100%, 0% 100%);
}

.logInBar_AnimIn_Email {
  animation-duration: 0.2s;
  animation-name: pop-up-error-message-on-email;
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
}

.logInBar_AnimIn_Password {
  animation-duration: 0.2s;
  animation-name: pop-up-error-message-on-password;
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
}

.logInBar_AnimIn_FullBar {
  animation-duration: 0.2s;
  animation-name: pop-up-error-message-full-bar;
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
}

#span_message_email {
  position: absolute;
  height: 5.23148%; 

  left: 10.4%;
  bottom: 3.4%;

  opacity: 0;

  background-color: transparent;
  border-color: transparent;
  font: normal normal normal 2cqh 'MyriadPro-Regular';
  color: white;

  animation-duration: 0.2s;
  animation-name: fade-in;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
}

#span_message_password {
  position: absolute;
  height: 5.23148%; 

  left: 31%;
  bottom: 3.4%;

  opacity: 0;

  background-color: transparent;
  border-color: transparent;
  font: normal normal normal 2cqh 'MyriadPro-Regular';
  color: white;

  animation-duration: 0.2s;
  animation-name: fade-in;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
}

#submitButton {
  width: 28.958333%;
  height: 6.7592%;
  position: absolute;

  bottom: -0.5px;

  border: 0;

  z-index: 2;

  pointer-events: none;

  clip-path: polygon(13.1% 0%, 86.9% 0%, 100% 100%, 0% 100%);

  transition: opacity 0.2s ease-in-out;
}

#submitButton:hover {
  opacity: 0;
}

#submitButton+#submitButtonHighlight {
  opacity: 1;
}

#submitButton:focus { 
    opacity: 0;
    transition: opacity 0.2s ease-in-out; 
}

#submitButtonHighlight {
  width: 29.24791633%;
  height: 6.7592%;
  position: absolute;

  bottom: -0.5px;
  right: 35.5521%;

  z-index: 1;

  opacity: 0;

  transition: opacity 0.2s ease-in-out;

  pointer-events: none;

  clip-path: polygon(13.7% 0%, 86.7% 0%, 99.7% 100%, 0.9% 100%);
}

#submitButtonNoText {
  width: 29.24791633%;
  height: 6.7592%;
  position: absolute;

  bottom: -0.5px;
  right: 21.42%;

  z-index: 13;

  pointer-events: none;

  clip-path: polygon(13.7% 0%, 86.7% 0%, 99.7% 100%, 0.9% 100%);
}

.submitButtonHighlight_StartAnim {
  animation-duration: 0.2s;
  animation-name: move-right;
  animation-fill-mode: forwards;
}

.submitButtonHighlight_EndAnim {
  animation-duration: 10ms;
  animation-name: submit-highlight-end;
  animation-fill-mode: forwards;
}

.submitButton_StartAnim {
  animation-duration: 0.2s;
  animation-name: submit-button-start;
  animation-fill-mode: forwards;
}

.submitButton_EndAnim {
  animation-duration: 0.8s;
  animation-name: submit-button-end;
  animation-fill-mode: forwards;
}

#password-visibility-button {
  position: absolute;

  aspect-ratio: 1;
  
  height: 45%;
  width: auto;

  left: 45.75%;
  top: 55%;
  bottom: 20%;
  transform: translate(0%, -50%);

  color: white;
  background-color: transparent;
  border: 0px;
}

#password-visibility-button:hover {
  color: goldenrod;
}

#password-visibility-button:focus {
color: goldenrod;
}

i {
  position: absolute;

  top: 0%;
  left: 0%;     

  width: 100%;
  height: 100%;
}

svg {
  position: absolute;

  width: 100%;
  height: 100%;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

}

#forgotPasswordButton {
  position:absolute;

  bottom:-0.08vh;
  
  width: 20.2%;
  height:5.6%;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: transparent;
  border: 0;

  opacity: 0;

  clip-path: polygon(0% 0%, 85.9% 0%, 100% 100%, 0% 100%);
}

#forgotPasswordButton:hover span {
  color: goldenrod;
}

#forgotPasswordButton:focus span {
  color: goldenrod;
}

.forgotPasswordButton_StartAnim {
  animation-duration: 0.4s;
  animation-name: start-move-right-fpw-button;
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
}

.forgotPasswordButton_EndAnim {
  animation-duration: 0.4s;
  animation-name: end-move-left-fpw-button;
  animation-fill-mode: forwards;
}

#forgotPasswordButton:focus+#fpw_span {
  color: goldenrod; 
}

#fpw_span {
  position: absolute;
  top: 50%;
  left: 50%;

  width: 100%;

  opacity: 0;

  transform: translate(-50%, -50%);

  color: white;
  font: 2.2cqh 'MyriadPro-Regular';
  line-height: 1cqh;

  pointer-events: none;

  animation-duration: 0.5s;
  animation-name: fade-in;
  animation-fill-mode: forwards;
  animation-delay: 0.4s;
}

#forgotPasswordButton:hover+#fpw_span {
  color: goldenrod;
}

#loadingLogin {
  position: absolute;

  width: 100%;
  height: 100%;

  z-index: 12;

  background-color: rgba(0, 0, 0, 0.6);
}

#loadingText {
  position: absolute;

  bottom: 1.5%;
  left: 60.5%;
  transform: translate(0%);

  z-index: 14;

  text-transform: uppercase;

  color: white;

  font: 1.4vw MyriadPro-Regular;
  font-weight: bold;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


@keyframes move-right {
  from {
    right: 35.5521%;
  }

  to {
    right: 8.5%;
    right: 21.5%;
  }
}

@keyframes start-move-left-LII {
  from {left: 85%;}

  to {left: 0%}
}

@keyframes end-move-right-LII {
  from {
    left: 0%;
  }

  99% {
    opacity: 1;
  }

  to {
    left: 85%;
    opacity: 0;
  }
}

@keyframes submit-button-start {
  from {
    right: 35.5521%;
    pointer-events: none;
  }

  99% {
    pointer-events: none;
  }

  to {
    right: 21.5%;
    pointer-events: all;
  }
}

@keyframes submit-button-end {
  0% {
    right: 21.5%;
    opacity: 1;

    pointer-events: none;
  }
  
  50% {
    right: 21.5%;
    opacity: 1;
    
    pointer-events: none;
  }

  75% {
    right: 35.5521%;
    opacity: 1;
    bottom: 0%;

    pointer-events: none;
  }

  100% {
    right: 35.5521%;
    opacity: 1; 
    bottom: -7%;

    pointer-events: none;
  }
}

@keyframes submit-highlight-end {
  from {opacity: 0;}
  
  to {
    opacity: 0;
  }
}

@keyframes start-move-right-fpw-button {
  from {
    opacity: 1;
    right: 22%;
  }

  99% {
    pointer-events: none;
  }

  to {
    opacity: 1;
    right: 4.8%;
    pointer-events: all;
  }
}

@keyframes end-move-left-fpw-button {
  from {
    opacity: 1;
    right: 4.8%;    
    pointer-events: none;
  }

  50% {
    opacity: 1;
    pointer-events: none;
  }

  to {
    opacity: 0;
    right: 22%;
    pointer-events: none;
  }
}

@keyframes pop-up-error-message-on-email {
  from {
    opacity: 1;
  }
  
  to {
    left: 5.64%;
    bottom: 4.9%;

    opacity: 1;
  }
}

@keyframes pop-up-error-message-on-password {
  from {
    opacity: 1;
  }
  
  to {
    left: 27.1%;
    bottom: 4.9%;

    opacity: 1;
  }
}

@keyframes pop-up-error-message-full-bar {
  from {
    opacity: 1;
  }
  
  to {
    left: 5.7%;
    bottom: 4.9%;

    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LogIn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;;EAEX,oBAAoB;;EAEpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;AACb;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;;EAEhB,QAAQ;EACR,WAAW;;EAEX,YAAY;;EAEZ,aAAa;EACb,YAAY;EACZ,gBAAgB;;EAEhB,mDAAmD;EACnD,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;;EAEb,kBAAkB;EAClB,WAAW;EACX,QAAQ;;EAER,UAAU;EACV,gBAAgB;;EAEhB,mDAA4D;EAC5D,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;;EAEb,kBAAkB;;EAElB,WAAW;EACX,SAAS;;EAET,WAAW;EACX,YAAY;;EAEZ,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;;EAEZ,cAAc;EACd,UAAU;;EAEV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf,aAAa;AACf;;AAEA;EACE,yDAAuE;EACvE,sBAAsB;;EAEtB,UAAU;EACV,UAAU;;EAEV,oBAAoB;AACtB;AACA;EACE,yDAA6E;EAC7E,sBAAsB;;EAEtB,UAAU;EACV,UAAU;;EAEV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,cAAc;EACd,UAAU;;EAEV,UAAU;;EAEV,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,WAAW;EACX,UAAU;;EAEV,UAAU;;EAEV,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,cAAc;EACd,UAAU;;EAEV,UAAU;;EAEV,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,WAAW;EACX,YAAY;;EAEZ,UAAU;;EAEV,6BAA6B;EAC7B,yBAAyB;EACzB,mDAAmD;EACnD,YAAY;;EAEZ,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,SAAS;EACT,YAAY;;EAEZ,UAAU;;EAEV,6BAA6B;EAC7B,yBAAyB;EACzB,mDAAmD;EACnD,YAAY;;EAEZ,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;;EAElB,cAAc;;EAEd,SAAS;;EAET,UAAU;;EAEV,oBAAoB;;EAEpB,0DAA0D;;EAE1D,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;;EAElB,cAAc;EACd,eAAe;;EAEf,UAAU;;EAEV,UAAU;;EAEV,oCAAoC;;EAEpC,oBAAoB;;EAEpB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;;EAElB,cAAc;EACd,aAAa;;EAEb,WAAW;;EAEX,oBAAoB;;EAEpB,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;;EAElB,eAAe;;EAEf,WAAW;EACX,WAAW;;EAEX,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,8BAA8B;;EAE9B,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA,gBAAgB;AAChB;;AAEA;EACE,kBAAkB;;EAElB,OAAO;EACP,QAAQ;;EAER,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,QAAQ;EACR,SAAS;EACT,gCAAgC;;AAElC;;AAEA;EACE,iBAAiB;;EAEjB,cAAc;;EAEd,YAAY;EACZ,WAAW;;EAEX,yDAA+E;EAC/E,6BAA6B;EAC7B,SAAS;;EAET,UAAU;;EAEV,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;;EAET,WAAW;;EAEX,UAAU;;EAEV,gCAAgC;;EAEhC,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;;EAEjB,oBAAoB;;EAEpB,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,WAAW;;EAEX,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;;EAElB,YAAY;EACZ,WAAW;EACX,wBAAwB;;EAExB,WAAW;;EAEX,yBAAyB;;EAEzB,YAAY;;EAEZ,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,MAAM,SAAS,CAAC;;EAEhB,IAAI,QAAQ;AACd;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;;IAEV,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,UAAU;;IAEV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,UAAU;;IAEV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,WAAW;;IAEX,oBAAoB;EACtB;AACF;;AAEA;EACE,MAAM,UAAU,CAAC;;EAEjB;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;;IAEZ,UAAU;EACZ;AACF","sourcesContent":["#logInContainer {\r\n  display: flex;\r\n\r\n  aspect-ratio: 16/9;\r\n  max-width: 100vw;\r\n  max-height: 100vh;\r\n\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n#logInDiv {\r\n  position: relative;\r\n  aspect-ratio: 16/9;\r\n  max-width: 177.778vh;\r\n  max-height: 56.25vw;\r\n  width: 100%;\r\n\r\n  container-type: size;\r\n\r\n  overflow: hidden;\r\n}\r\n\r\n#emailInput {\r\n  position: absolute;\r\n\r\n  left: 8.07%;\r\n}\r\n\r\n#passwordInput {\r\n  position: absolute;\r\n\r\n  left: 29.4%;\r\n  width: 16%;\r\n}\r\n\r\n.textInputs {\r\n  text-align: left;\r\n\r\n  top: 30%;\r\n  bottom: 23%;\r\n\r\n  width: 17.7%;\r\n\r\n  outline: none;\r\n  border: none;\r\n  background: none;\r\n\r\n  font: normal normal normal 100% 'MyriadPro-Regular';\r\n  font-size: 35cqh;\r\n  color: white;\r\n}\r\n\r\n.textInputs::selection {\r\n  background: white\r\n}\r\n\r\n.mask_logInInputs {\r\n  display: flex;\r\n\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 0%;\r\n\r\n  width: 55%;\r\n  height: 5.23148%;\r\n\r\n  mask-image: url(../../public/Images/LogIn/LogInBar_mask.png);\r\n  mask-repeat: no-repeat;    \r\n  mask-size: cover;\r\n}\r\n\r\n#logInInputs {\r\n  display: flex;\r\n\r\n  position: absolute;\r\n\r\n  bottom: 0px;\r\n  left: 85%;\r\n\r\n  width: 182%;\r\n  height: 100%;\r\n\r\n  container-type: size;\r\n}\r\n\r\n.logInInputs_StartAnim {\r\n  animation-duration: 0.4s;\r\n  animation-name: start-move-left-LII;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.logInInputs_EndAnim {\r\n  animation-duration: 0.4s;\r\n  animation-name: end-move-right-LII;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n#logInBar {\r\n  position: absolute;\r\n  height: 100%;\r\n\r\n  left: 3.15104%;\r\n  bottom: 0%;\r\n\r\n  opacity: 1;\r\n}\r\n\r\n#email_outline {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 21.4836%;\r\n\r\n  left: 6.18%;\r\n}\r\n\r\n#password_outline {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 21.4836%;\r\n\r\n  left: 27.469%;\r\n}\r\n\r\n.outlineWhite {\r\n  background-image: url(../../public/Images/LogIn/InputOutline_LogIn.png);\r\n  background-size: cover;\r\n\r\n  opacity: 1;\r\n  z-index: 1;\r\n\r\n  pointer-events: none;\r\n}\r\n.outlineRed {\r\n  background-image: url(../../public/Images/LogIn/InputOutline_Error_LogIn.png);\r\n  background-size: cover;\r\n\r\n  opacity: 1;\r\n  z-index: 1;\r\n\r\n  pointer-events: none;\r\n}\r\n\r\n#logInBar_message_email {\r\n  position: absolute;\r\n  height: 5.23148%; \r\n\r\n  left: 3.15104%;\r\n  bottom: 0%;\r\n\r\n  opacity: 0;\r\n\r\n  clip-path: polygon(0% 0%, 52% 0%, 46.5% 100%, 0% 100%);\r\n}\r\n\r\n#logInBar_message_password {\r\n  position: absolute;\r\n  height: 5.23148%; \r\n\r\n  left: 24.5%;\r\n  bottom: 0%;\r\n\r\n  opacity: 0;\r\n\r\n  clip-path: polygon(0% 0%, 56.5% 0%, 50.7% 100%, 0% 100%);\r\n}\r\n\r\n#logInBar_message_fullBar {\r\n  position: absolute;\r\n  height: 5.23148%; \r\n\r\n  left: 3.15104%;\r\n  bottom: 0%;\r\n\r\n  opacity: 0;\r\n\r\n  clip-path: polygon(0% 0%, 99.6% 0%, 94% 100%, 0% 100%);\r\n}\r\n\r\n.logInBar_AnimIn_Email {\r\n  animation-duration: 0.2s;\r\n  animation-name: pop-up-error-message-on-email;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.logInBar_AnimIn_Password {\r\n  animation-duration: 0.2s;\r\n  animation-name: pop-up-error-message-on-password;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.logInBar_AnimIn_FullBar {\r\n  animation-duration: 0.2s;\r\n  animation-name: pop-up-error-message-full-bar;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n#span_message_email {\r\n  position: absolute;\r\n  height: 5.23148%; \r\n\r\n  left: 10.4%;\r\n  bottom: 3.4%;\r\n\r\n  opacity: 0;\r\n\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  font: normal normal normal 2cqh 'MyriadPro-Regular';\r\n  color: white;\r\n\r\n  animation-duration: 0.2s;\r\n  animation-name: fade-in;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.5s;\r\n}\r\n\r\n#span_message_password {\r\n  position: absolute;\r\n  height: 5.23148%; \r\n\r\n  left: 31%;\r\n  bottom: 3.4%;\r\n\r\n  opacity: 0;\r\n\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  font: normal normal normal 2cqh 'MyriadPro-Regular';\r\n  color: white;\r\n\r\n  animation-duration: 0.2s;\r\n  animation-name: fade-in;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.5s;\r\n}\r\n\r\n#submitButton {\r\n  width: 28.958333%;\r\n  height: 6.7592%;\r\n  position: absolute;\r\n\r\n  bottom: -0.5px;\r\n\r\n  border: 0;\r\n\r\n  z-index: 2;\r\n\r\n  pointer-events: none;\r\n\r\n  clip-path: polygon(13.1% 0%, 86.9% 0%, 100% 100%, 0% 100%);\r\n\r\n  transition: opacity 0.2s ease-in-out;\r\n}\r\n\r\n#submitButton:hover {\r\n  opacity: 0;\r\n}\r\n\r\n#submitButton+#submitButtonHighlight {\r\n  opacity: 1;\r\n}\r\n\r\n#submitButton:focus { \r\n    opacity: 0;\r\n    transition: opacity 0.2s ease-in-out; \r\n}\r\n\r\n#submitButtonHighlight {\r\n  width: 29.24791633%;\r\n  height: 6.7592%;\r\n  position: absolute;\r\n\r\n  bottom: -0.5px;\r\n  right: 35.5521%;\r\n\r\n  z-index: 1;\r\n\r\n  opacity: 0;\r\n\r\n  transition: opacity 0.2s ease-in-out;\r\n\r\n  pointer-events: none;\r\n\r\n  clip-path: polygon(13.7% 0%, 86.7% 0%, 99.7% 100%, 0.9% 100%);\r\n}\r\n\r\n#submitButtonNoText {\r\n  width: 29.24791633%;\r\n  height: 6.7592%;\r\n  position: absolute;\r\n\r\n  bottom: -0.5px;\r\n  right: 21.42%;\r\n\r\n  z-index: 13;\r\n\r\n  pointer-events: none;\r\n\r\n  clip-path: polygon(13.7% 0%, 86.7% 0%, 99.7% 100%, 0.9% 100%);\r\n}\r\n\r\n.submitButtonHighlight_StartAnim {\r\n  animation-duration: 0.2s;\r\n  animation-name: move-right;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.submitButtonHighlight_EndAnim {\r\n  animation-duration: 10ms;\r\n  animation-name: submit-highlight-end;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.submitButton_StartAnim {\r\n  animation-duration: 0.2s;\r\n  animation-name: submit-button-start;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.submitButton_EndAnim {\r\n  animation-duration: 0.8s;\r\n  animation-name: submit-button-end;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n#password-visibility-button {\r\n  position: absolute;\r\n\r\n  aspect-ratio: 1;\r\n  \r\n  height: 45%;\r\n  width: auto;\r\n\r\n  left: 45.75%;\r\n  top: 55%;\r\n  bottom: 20%;\r\n  transform: translate(0%, -50%);\r\n\r\n  color: white;\r\n  background-color: transparent;\r\n  border: 0px;\r\n}\r\n\r\n#password-visibility-button:hover {\r\n  color: goldenrod;\r\n}\r\n\r\n#password-visibility-button:focus {\r\ncolor: goldenrod;\r\n}\r\n\r\ni {\r\n  position: absolute;\r\n\r\n  top: 0%;\r\n  left: 0%;     \r\n\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\nsvg {\r\n  position: absolute;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n\r\n}\r\n\r\n#forgotPasswordButton {\r\n  position:absolute;\r\n\r\n  bottom:-0.08vh;\r\n  \r\n  width: 20.2%;\r\n  height:5.6%;\r\n\r\n  background-image: url(../../public/Images/LogIn/password_reset_background.webp);\r\n  background-color: transparent;\r\n  border: 0;\r\n\r\n  opacity: 0;\r\n\r\n  clip-path: polygon(0% 0%, 85.9% 0%, 100% 100%, 0% 100%);\r\n}\r\n\r\n#forgotPasswordButton:hover span {\r\n  color: goldenrod;\r\n}\r\n\r\n#forgotPasswordButton:focus span {\r\n  color: goldenrod;\r\n}\r\n\r\n.forgotPasswordButton_StartAnim {\r\n  animation-duration: 0.4s;\r\n  animation-name: start-move-right-fpw-button;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.forgotPasswordButton_EndAnim {\r\n  animation-duration: 0.4s;\r\n  animation-name: end-move-left-fpw-button;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n#forgotPasswordButton:focus+#fpw_span {\r\n  color: goldenrod; \r\n}\r\n\r\n#fpw_span {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n\r\n  width: 100%;\r\n\r\n  opacity: 0;\r\n\r\n  transform: translate(-50%, -50%);\r\n\r\n  color: white;\r\n  font: 2.2cqh 'MyriadPro-Regular';\r\n  line-height: 1cqh;\r\n\r\n  pointer-events: none;\r\n\r\n  animation-duration: 0.5s;\r\n  animation-name: fade-in;\r\n  animation-fill-mode: forwards;\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n#forgotPasswordButton:hover+#fpw_span {\r\n  color: goldenrod;\r\n}\r\n\r\n#loadingLogin {\r\n  position: absolute;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  z-index: 12;\r\n\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n#loadingText {\r\n  position: absolute;\r\n\r\n  bottom: 1.5%;\r\n  left: 60.5%;\r\n  transform: translate(0%);\r\n\r\n  z-index: 14;\r\n\r\n  text-transform: uppercase;\r\n\r\n  color: white;\r\n\r\n  font: 1.4vw MyriadPro-Regular;\r\n  font-weight: bold;\r\n}\r\n\r\n@keyframes fade-in {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n@keyframes move-right {\r\n  from {\r\n    right: 35.5521%;\r\n  }\r\n\r\n  to {\r\n    right: 8.5%;\r\n    right: 21.5%;\r\n  }\r\n}\r\n\r\n@keyframes start-move-left-LII {\r\n  from {left: 85%;}\r\n\r\n  to {left: 0%}\r\n}\r\n\r\n@keyframes end-move-right-LII {\r\n  from {\r\n    left: 0%;\r\n  }\r\n\r\n  99% {\r\n    opacity: 1;\r\n  }\r\n\r\n  to {\r\n    left: 85%;\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes submit-button-start {\r\n  from {\r\n    right: 35.5521%;\r\n    pointer-events: none;\r\n  }\r\n\r\n  99% {\r\n    pointer-events: none;\r\n  }\r\n\r\n  to {\r\n    right: 21.5%;\r\n    pointer-events: all;\r\n  }\r\n}\r\n\r\n@keyframes submit-button-end {\r\n  0% {\r\n    right: 21.5%;\r\n    opacity: 1;\r\n\r\n    pointer-events: none;\r\n  }\r\n  \r\n  50% {\r\n    right: 21.5%;\r\n    opacity: 1;\r\n    \r\n    pointer-events: none;\r\n  }\r\n\r\n  75% {\r\n    right: 35.5521%;\r\n    opacity: 1;\r\n    bottom: 0%;\r\n\r\n    pointer-events: none;\r\n  }\r\n\r\n  100% {\r\n    right: 35.5521%;\r\n    opacity: 1; \r\n    bottom: -7%;\r\n\r\n    pointer-events: none;\r\n  }\r\n}\r\n\r\n@keyframes submit-highlight-end {\r\n  from {opacity: 0;}\r\n  \r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes start-move-right-fpw-button {\r\n  from {\r\n    opacity: 1;\r\n    right: 22%;\r\n  }\r\n\r\n  99% {\r\n    pointer-events: none;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    right: 4.8%;\r\n    pointer-events: all;\r\n  }\r\n}\r\n\r\n@keyframes end-move-left-fpw-button {\r\n  from {\r\n    opacity: 1;\r\n    right: 4.8%;    \r\n    pointer-events: none;\r\n  }\r\n\r\n  50% {\r\n    opacity: 1;\r\n    pointer-events: none;\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    right: 22%;\r\n    pointer-events: none;\r\n  }\r\n}\r\n\r\n@keyframes pop-up-error-message-on-email {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  \r\n  to {\r\n    left: 5.64%;\r\n    bottom: 4.9%;\r\n\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes pop-up-error-message-on-password {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  \r\n  to {\r\n    left: 27.1%;\r\n    bottom: 4.9%;\r\n\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes pop-up-error-message-full-bar {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  \r\n  to {\r\n    left: 5.7%;\r\n    bottom: 4.9%;\r\n\r\n    opacity: 1;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
